import { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { GET_LISTDATA } from "../../actions";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { adminlimit } from "../Settings/Config";
import api from "../../utils/axios";
import { showContaimerLoader, encodeValue, removeItem, showPageCount, calculateAge, showDBDate, hasPermission } from "../Settings/Settings";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import Pagenation from "../Layout/Pagenation";
const module = "candidate";
const modulePath = "/candidate";
const moduleName = "Search";
const moduleID = 13;
class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSearch: false,
      pageLimit: { label: adminlimit, value: adminlimit },
      loading: true,
      totalRecords: 0,
      totalPage: 0,
      currentPage: 1,
      listdata: [],
      name: "",
      status: "",
      nemoID: "",
      nemoName: "",
      c_rank: "",
      c_vessel: "",
      experience: "",
      grade: "",
      avb_date_from: "",
      avb_date_to: "",
      l_country: "",
      zone: "",
      group: "",
      age_from: "",
      age_to: "",
      c_mobile: "",
      c_email: "",
      searchKeyword_V:"",
      advanceSearch: false,
      rankList: [],
      experienceList: [],
      countryList: [],
      vessleTypeList: [],
      gradeList: [],
    };
    this.handleChangeText = this.handleChangeText.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }
  componentDidMount() {
    this.loadDropdown();
    const searchkeyword = this.props.location?.state?.searchkeyword || "";
    if (searchkeyword !== "") {
      this.setState({ name: searchkeyword }, () => {
        console.log(this.state.name, "namenamenamename");
        this.setState({ loading: true, currentPage: 1, showSearch: true }, () => {
          this.loadList(1);
        });
      });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.listdata !== this.state.listdata) {
      this.setState({
        listdata: nextProps.listdata,
        loading: false,
        totalRecords: nextProps.totalRecords,
        totalPage: nextProps.totalPages,
      });
    }
  }
  loadDropdown() {
    api
      .get("rank/dropdown")
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ rankList: res.data.result });
        }
      })
      .catch((err) => {
        console.error(err);
      });
    api
      .get("experience/dropdown")
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ experienceList: res.data.result });
        }
      })
      .catch((err) => {
        console.error(err);
      });
    api
      .get("vesseltype/dropdown")
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ vessleTypeList: res.data.result });
        }
      })
      .catch((err) => {
        console.error(err);
      });

    api
      .get("others/countrylist")
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ countryList: res.data.result });
        }
      })
      .catch((err) => {
        console.error(err);
      });
    api
      .get("grade/dropdown")
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ gradeList: res.data.result });
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }
  searchList(searchType='main', e) {
    e.preventDefault();
    let searchKeyword_V = this.state.searchKeyword_V;
    if(searchType==="main") {
      searchKeyword_V = '';
    }
    this.setState({ loading: true, currentPage: 1, showSearch: true, searchType:searchType, searchKeyword_V }, () => {
      this.loadList(1);
    });
  }
  advanceSearch(e) {
    e.preventDefault();
    this.setState({ advanceSearch: !this.state.advanceSearch, name: "" });
  }
  resetSearch(e) {
    e.preventDefault();
    this.setState(
      {
        showSearch: false,
        name: "",
        status: "",
        nemoID: "",
        nemoName: "",
        c_rank: "",
        c_vessel: "",
        experience: "",
        grade: "",
        avb_date_from: "",
        avb_date_to: "",
        l_country: "",
        zone: "",
        group: "",
        age_from: "",
        age_to: "",
        c_mobile: "",
        c_email: "",
        totalRecords: 0,
        totalPage: 0,
        currentPage: 1,
        listdata: [],
      },
      () => {
        this.props.history.push("/search");
      },
    );
  }
  loadList(offset) {
    this.setState({ loading: true });
    let addParams = "";
    console.log(this.state.name, "this.state.namethis.state.namethis.state.name");
    if (this.state.name !== "") {
      addParams += "&name=" + encodeURIComponent(this.state.name);
    }
    const nemoID = this.state.nemoID;
    if (nemoID.trim() !== "") {
      addParams += `&nemoID=${nemoID}`;
    }
    const nemoName = this.state.nemoName;
    if (nemoName.trim() !== "") {
      addParams += `&nemoName=${nemoName}`;
    }
    const c_rank = this.state.c_rank?.value ?? "";
    if (c_rank.trim() !== "") {
      addParams += `&c_rank=${c_rank}`;
    }
    const c_vessel = this.state.c_vessel?.value ?? "";
    if (c_vessel.trim() !== "") {
      addParams += `&c_vessel=${c_vessel}`;
    }
    const experience = this.state.experience?.value ?? "";
    if (experience.trim() !== "") {
      addParams += `&experience=${experience}`;
    }
    const grade = this.state.grade?.value ?? "";
    if (grade.trim() !== "") {
      addParams += `&grade=${grade}`;
    }
    const avb_date_from = this.state.avb_date_from;
    if (avb_date_from !== "") {
      addParams += `&avb_date_from=${showDBDate(avb_date_from)}`;
    }
    const avb_date_to = this.state.avb_date_to;
    if (avb_date_to !== "") {
      addParams += `&avb_date_to=${showDBDate(avb_date_to)}`;
    }
    const l_country = this.state.l_country?.value ?? "";
    if (l_country !== "") {
      addParams += `&l_country=${l_country}`;
    }
    const zone = this.state.zone?.value ?? "";
    if (zone !== "") {
      addParams += `&zone=${zone}`;
    }
    const group = this.state.group?.value ?? "";
    if (group !== "") {
      addParams += `&group=${group}`;
    }
    const age_from = this.state.age_from;
    if (age_from.trim() !== "") {
      addParams += `&age_from=${age_from}`;
    }
    const age_to = this.state.age_to;
    if (age_to.trim() !== "") {
      addParams += `&age_to=${age_to}`;
    }
    const c_mobile = this.state.c_mobile;
    if (c_mobile.trim() !== "") {
      addParams += `&c_mobile=${c_mobile}`;
    }
    const c_email = this.state.c_email;
    if (c_email.trim() !== "") {
      addParams += `&c_email=${c_email}`;
    }
    const searchKeyword_V = this.state.searchKeyword_V;
    if (searchKeyword_V.trim() !== "") {
      addParams += `&searchKeyword=${searchKeyword_V}`;
    }

    
    console.log(addParams, "addParams");
    const params = {
      params: "limit=" + this.state.pageLimit.value + "&offset=" + offset + addParams,
      url: `${module}/search`,
    };
    this.props.getListData(params);
  }
  edit(editID, e) {
    e.preventDefault();
    this.props.history.push(`${modulePath}/view/${editID}`);
  }
  sateValChange = (field, value) => {
    if (field === "page") {
      if (this.state.currentPage !== value) {
        this.setState(
          {
            loading: true,
            currentPage: value,
          },
          () => {
            this.loadList(value);
          },
        );
      }
    } else if (field === "pageLimit") {
      this.setState({ pageLimit: value, currentPage: 1 }, () => {
        this.loadList(1);
      });
    }
  };
  handleChangeText(event) {
    const name = event.target.name;
    let value = event.target.value;
    if (["nemoID", "c_mobile", "age_from", "age_to"].indexOf(name) >= 0) {
      value = value.replace(/[^0-9]/g, "");
    }
    this.setState({ [name]: value });
  }
  handleKeyDown = (event) => {
    if (event.key === "Enter") {
      this.setState({ loading: true, currentPage: 1, showSearch: true }, () => {
        this.loadList(1);
      });
    }
  };

  handleSelectChange(name, value) {
    this.setState({ [name]: value });
  }
  removeItem(deleteID, e) {
    e.preventDefault();
    removeItem(deleteID, module, this.sateValChange, this.state.currentPage);
  }

  render() {
    return (
      <div>
        <div className="page">
          <div className="page-main">
            <Header currentPage="search" {...this.props} />

            <div className="main-content app-content">
              <div className="side-app">
                <div className="main-container container-fluid mx-3">
                  <div className="page-header">
                    <h1 className="page-title">{moduleName}</h1>
                    <div>
                      {hasPermission(moduleID, "add") && (
                        <ol className="breadcrumb">
                          <li className="breadcrumb-item">
                            <Link to={`${modulePath}/add`}>
                              <button className="btn btn-sm btn-success badge" type="button">
                                <i className="fa fa-plus"></i> Add New
                              </button>
                            </Link>
                          </li>
                        </ol>
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 col-xl-12">
                      <div className="card">
                        <div className="card-body">
                          <div className="form-row">
                            {this.state.advanceSearch === false ? (
                              <div className="col-md-6">
                                <label className="form-label">Search keyword</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder={"Search keyword"}
                                  name="name"
                                  onChange={this.handleChangeText}
                                  onKeyDown={this.handleKeyDown}
                                  value={this.state.name || ""}
                                  autoComplete="off"
                                />
                              </div>
                            ) : (
                              <>
                                <div className="col-md-3">
                                  <label className="form-label">Nemo ID</label>
                                  <input type="text" className="form-control" placeholder={"Nemo ID"} name="nemoID" onChange={this.handleChangeText} value={this.state.nemoID} autoComplete="off" />
                                </div>
                                <div className="col-md-3">
                                  <label className="form-label">Name</label>
                                  <input
                                    type="text"
                                    className="form-control upper-case"
                                    placeholder={"Name"}
                                    name="nemoName"
                                    onChange={this.handleChangeText}
                                    value={this.state.nemoName}
                                    autoComplete="off"
                                  />
                                </div>
                                <div className="col-md-3">
                                  <label className="form-label">Mobile</label>
                                  <input type="text" className="form-control" placeholder={"Mobile"} name="c_mobile" onChange={this.handleChangeText} value={this.state.c_mobile} autoComplete="off" />
                                </div>
                                <div className="col-md-3">
                                  <label className="form-label">Email</label>
                                  <input type="text" className="form-control " placeholder={"Email"} name="c_email" onChange={this.handleChangeText} value={this.state.c_email} autoComplete="off" />
                                </div>
                                <div className="col-md-3">
                                  <label className="form-label">Rank</label>
                                  <Select
                                    value={this.state.c_rank}
                                    onChange={this.handleSelectChange.bind(this, "c_rank")}
                                    placeholder="Select Rank Experience"
                                    isClearable={true}
                                    options={this.state.rankList}
                                  />
                                </div>
                                <div className="col-md-3">
                                  <label className="form-label">Vessel</label>
                                  <Select
                                    value={this.state.c_vessel}
                                    onChange={this.handleSelectChange.bind(this, "c_vessel")}
                                    placeholder="Select Vessel Type"
                                    isClearable={true}
                                    options={this.state.vessleTypeList}
                                  />
                                </div>
                                <div className="col-md-3">
                                  <label className="form-label">Experience</label>
                                  <Select
                                    value={this.state.experience}
                                    onChange={this.handleSelectChange.bind(this, "experience")}
                                    placeholder="Select Experience"
                                    isClearable={true}
                                    options={this.state.experienceList}
                                  />
                                </div>
                                <div className="col-md-3">
                                  <label className="form-label">Grade</label>
                                  <Select
                                    value={this.state.grade}
                                    onChange={this.handleSelectChange.bind(this, "grade")}
                                    placeholder="Select Grade"
                                    isClearable={true}
                                    options={this.state.gradeList}
                                  />
                                </div>
                                <div className="col-md-3">
                                  <label className="form-label">Available From</label>
                                  <DatePicker
                                    peekNextMonth
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    placeholderText="Select Available From"
                                    className="form-control"
                                    onKeyDown={(e) => e.preventDefault()}
                                    selected={this.state.avb_date_from}
                                    dateFormat="dd-MM-yyyy"
                                    onChange={this.handleSelectChange.bind(this, "avb_date_from")}
                                    isClearable={this.state.avb_date_from !== "" ? true : false}
                                  />
                                </div>
                                <div className="col-md-3">
                                  <label className="form-label">Available To</label>
                                  <DatePicker
                                    peekNextMonth
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    placeholderText="Select Available To"
                                    className="form-control"
                                    onKeyDown={(e) => e.preventDefault()}
                                    selected={this.state.avb_date_to}
                                    dateFormat="dd-MM-yyyy"
                                    minDate={this.state.avb_date_from !== "" ? this.state.avb_date_from : ""}
                                    onChange={this.handleSelectChange.bind(this, "avb_date_to")}
                                    isClearable={this.state.avb_date_to !== "" ? true : false}
                                  />
                                </div>
                                <div className="col-md-3">
                                  <label className="form-label">License Country</label>
                                  <Select
                                    value={this.state.l_country}
                                    onChange={this.handleSelectChange.bind(this, "l_country")}
                                    placeholder="Select License Country"
                                    isClearable={true}
                                    options={this.state.countryList}
                                  />
                                </div>
                                <div className="col-md-3">
                                  <label className="form-label">Zone</label>
                                  <Select
                                    value={this.state.zone}
                                    onChange={this.handleSelectChange.bind(this, "zone")}
                                    placeholder="Select Zone"
                                    isClearable={true}
                                    options={[
                                      { label: "East", value: "East" },
                                      { label: "West", value: "West" },
                                      { label: "North", value: "North" },
                                      { label: "South", value: "South" },
                                    ]}
                                  />
                                </div>
                                <div className="col-md-3">
                                  <label className="form-label">Group</label>
                                  <Select
                                    value={this.state.group}
                                    onChange={this.handleSelectChange.bind(this, "group")}
                                    placeholder="Select Group"
                                    isClearable={true}
                                    options={[
                                      { label: "Officer", value: "1" },
                                      { label: "Rating", value: "2" },
                                      { label: "IV crew", value: "6" },
                                    ]}
                                  />
                                </div>
                                <div className="col-md-1">
                                  <label className="form-label">From Age</label>
                                  <input
                                    type="text"
                                    className="form-control upper-case"
                                    placeholder={"From Age"}
                                    name="age_from"
                                    onChange={this.handleChangeText}
                                    maxLength={2}
                                    value={this.state.age_from}
                                    autoComplete="off"
                                  />
                                </div>
                                <div className="col-md-1">
                                  <label className="form-label">To Age</label>
                                  <input
                                    type="text"
                                    className="form-control upper-case"
                                    placeholder={"To Age"}
                                    name="age_to"
                                    onChange={this.handleChangeText}
                                    maxLength={2}
                                    value={this.state.age_to}
                                    autoComplete="off"
                                  />
                                </div>
                              </>
                            )}
                            <div className="col-md-5">
                              <a href="/" className="btn btn-primary mt-6" onClick={this.searchList.bind(this, 'main')}>
                                Search
                              </a>
                              <a href="/" className="btn btn-info offset-1 mt-6" onClick={this.advanceSearch.bind(this)}>
                                {this.state.advanceSearch === true ? "Close " : ""}Advanced Search
                              </a>
                              <a href="/" className="btn btn-secondary offset-1 mt-6" onClick={this.resetSearch.bind(this)}>
                                Reload
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {this.state.showSearch === true && (
                    <div className="row">
                      <div className="col-xl-12">
                        <div className="card">
                          {this.state.loading ? (
                            showContaimerLoader()
                          ) : (
                            <div>
                              <div className="card-header">
                                {parseInt(this.state.totalPage) > 0 && (
                                  <>
                                    <h3 className="card-title">
                                      Page: <b>{this.state.currentPage}</b> of <b>{this.state.totalPage}</b> {moduleName}, Total Record: {this.state.totalRecords}
                                    </h3>
                                    <div className="card-options">
                                      <div class="form-row">
                                        <div class="col-md-8">
                                          <input class="form-control" placeholder="Search keyword" type="text" name="searchKeyword_V" value={this.state.searchKeyword_V} onChange={this.handleChangeText}  />
                                        </div>
                                        <div class="col-md-1">
                                          <a href="/" class="btn btn-primary" onClick={this.searchList.bind(this, 'inline')}>
                                            Search
                                          </a>
                                        </div>
                                      </div>
                                      <label className="mx-3 mt-2">Page Per</label>
                                      <Select
                                        value={this.state.pageLimit} // pass the selected option
                                        onChange={(selectedOption) => {
                                          // pass both field and value
                                          this.sateValChange(`pageLimit`, selectedOption || "");
                                        }}
                                        placeholder="Page Per"
                                        options={[
                                          { value: "10", label: "10" },
                                          { value: "25", label: "25" },
                                          { value: "50", label: "50" },
                                          { value: "100", label: "100" },
                                        ]}
                                      />
                                    </div>
                                  </>
                                )}
                              </div>
                              <div className="card-body">
                                <div className="table-responsive">
                                  <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                                    <thead className="table-primary">
                                      <tr>
                                        {(hasPermission(moduleID, "edit") || hasPermission(moduleID, "delete")) && <th className="text-center">Actions </th>}
                                        <th>S.No.</th>
                                        <th>Nemo ID</th>
                                        <th>Candidate Name</th>
                                        <th>Rank</th>
                                        <th>Vessel</th>
                                        <th>Mobile</th>
                                        <th>Age</th>
                                        <th>Email</th>
                                        <th>NTBR</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {this.state.listdata.length > 0 ? (
                                        this.state.listdata.map((item, index) => {
                                          let rowClass = "";
                                          if (item.active_details === 0) {
                                            rowClass = "bg-danger text-white";
                                          } else if (item.ntbr === "1" || item.ntbr === 1) {
                                            rowClass = "table-orange";
                                          } else if (item.ntbr === "0" || item.ntbr === 0) {
                                            rowClass = "table-yellow";
                                          }
                                          return (
                                            <tr key={index} className={rowClass}>
                                              {(hasPermission(moduleID, "edit") || hasPermission(moduleID, "delete")) && (
                                                <td className="text-center text-nowrap" valign="top">
                                                  {hasPermission(moduleID, "edit") && (
                                                    <a href="/" onClick={this.edit.bind(this, item.candidateId)} className="me-2">
                                                      <i className="fa fa-pencil-square-o"></i>
                                                    </a>
                                                  )}
                                                  {hasPermission(moduleID, "delete") && (
                                                    <a href="/" className="delete_record" onClick={this.removeItem.bind(this, encodeValue(item.candidateId))}>
                                                      <i className="fa fa-trash"></i>
                                                    </a>
                                                  )}
                                                </td>
                                              )}
                                              <td>{(parseInt(this.state.currentPage) - 1) * parseInt(this.state.pageLimit.value) + (parseInt(index) + 1)}</td>
                                              <td>
                                                <a href={`/candidate/view/${item.candidateId}`} target="_blank" rel="noreferrer">
                                                  <b>{item.candidateId}</b>
                                                </a>
                                              </td>
                                              <td>{item.name}</td>
                                              <td>{item.c_rank}</td>
                                              <td>{item.c_vessel}</td>
                                              <td>{item.c_mobi1}</td>
                                              <td>{calculateAge(item.dob)}</td>
                                              <td>{item.email1}</td>
                                              <td>
                                                {(item.ntbr === "1" || item.ntbr === 1) && <span className="badge bg-danger">Not Re-employed by Owners/Clients</span>}
                                                {(item.ntbr === "0" || item.ntbr === 0) && <span className="badge bg-warning">Not Re-employed by Nautilus</span>}
                                              </td>
                                            </tr>
                                          );
                                        })
                                      ) : (
                                        <tr>
                                          <td className="text-center" colSpan={10}>
                                            No {moduleName} Found
                                          </td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                                {parseInt(this.state.totalPage) > 1 && (
                                  <Pagenation
                                    params={{
                                      totalRecords: this.state.totalRecords,
                                      totalPage: this.state.totalPage,
                                      currentPage: this.state.currentPage,
                                    }}
                                    sateValChange={this.sateValChange}
                                  />
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  let listdata = [];
  let totalPages = 0;
  let totalRecords = 0;
  if (Object.keys(state.listdata).length > 0) {
    if (state.listdata[0].status === "ok") {
      listdata = state.listdata[0].result;
      totalPages = state.listdata[0].totalPages;
      totalRecords = state.listdata[0].totalRecords;
    }
  }
  return {
    listdata: listdata,
    totalPages: totalPages,
    totalRecords: totalRecords,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getListData: (datas) => {
      dispatch({ type: GET_LISTDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(List);
